

<template>
  <!-- <ModalContainer title="Evaluación odontológica" ref="modalContainer" >

  </ModalContainer> -->

  <b-row>
    <b-col>

      <b-card 
        :style="onlyView ? '' : isModalView" 
        no-body 
        :class="{ 'open': visibleBody }"
      >

        <b-card-header 
          style="color: black; font:45px; padding: 0 1px; cursor: pointer;"
          :class="{ 'collapsed': !visibleBody }" 
          :aria-expanded="visibleBody ? 'true' : 'false'" 
          role="tab"
          data-toggle="collapse" @click="onVisibleBody(!visibleBody)">
          <span class="lead collapse-title">
            <strong>EVALUACIÓN ODONTOLÓGICA</strong>
          </span>
          <i :class="visibleBody ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"></i>
        </b-card-header>
        
        <b-collapse v-model="visibleBody" role="tabpanel">
          <b-card-body style="margin:0;">
            
            <div>
              <PiezaDental 
                v-for="diente in cuadrante1" 
                :key="diente.id"
                :dataDiente="diente"
              />

            </div>

            <div class="mt-1">
              <PiezaDental 
                v-for="diente in cuadrante2" 
                :key="diente.id"
                :dataDiente="diente"
              />
            </div>
            
          </b-card-body>
        </b-collapse>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { ModalContainer } from "@/shared/components";

import PiezaDental from "./PiezaDental.vue"

export default {

  name: "EvaluacionOdontologica",

  props: {
    onlyView: {
      type: Boolean,
      default: false
    }
  },

  components: {
    ModalContainer,
    PiezaDental
  },

  data() {
    return {
      visibleBody: false,


      cuadrante1: [
        { 
          id: 11,
          faces:[],
          cuadrado1:[]
        },
        { 
          id: 12,
          faces:[],
          cuadrado1:[]
        },
        { 
          id: 13,
          faces:[],
          cuadrado1:[]
        },
        { 
          id: 14,
          faces:[],
          cuadrado1:[]
        },
        { 
          id: 15,
          faces:[],
          cuadrado1:[]
        },
        { 
          id: 16,
          faces:[],
          cuadrado1:[]
        },
        { 
          id: 17,
          faces:[],
          cuadrado1:[] 
        },
        { 
          id: 18,
          faces:[],
          cuadrado1:[]
        },
      ],

      cuadrante2: [
        { 
          id: 21,
          faces:[],
          cuadrado1:[]
        },
        { 
          id: 22,
          faces:[],
          cuadrado1:[]
        },
        { 
          id: 23,
          faces:[],
          cuadrado1:[]
        },
        { 
          id: 24,
          faces:[],
          cuadrado1:[]
        },
        { 
          id: 25,
          faces:[],
          cuadrado1:[]
        },
        { 
          id: 26,
          faces:[],
          cuadrado1:[]
        },
        { 
          id: 27,
          faces:[],
          cuadrado1:[]
        },
        { 
          id: 28,
          faces:[],
          cuadrado1:[]
        },
      ],

      cuadrante3: [
        { id: 31 },
        { id: 32 },
        { id: 33 },
        { id: 34 },
        { id: 35 },
        { id: 36 },
        { id: 37 },
        { id: 38 },
      ],

      cuadrante4: [
        { id: 41 },
        { id: 42 },
        { id: 43 },
        { id: 44 },
        { id: 45 },
        { id: 46 },
        { id: 47 },
        { id: 48 },
      ],
    };

  },


  methods:{
    onVisibleBody(value) {
      this.visibleBody = value
    },
  },


  computed: {
    isModalView() {
      return {
        margin: '0',
        border: '1px solid #2980b9',
        padding: '0 10px'

      }
    }
  },
}
</script>

<style>

</style>